module.exports = __webpack_public_path__ + "img/pay.3aeb998a.png";